import { combineReducers } from 'redux';

import { connectRouter } from 'connected-react-router';

import form from './form';
import scenes from './scenes';
import dataset from './dataset';
import selectedStats from './selectedStats';
import mode from './mode';

export default history => combineReducers({
  router: connectRouter(history),
  mode,
  selectedStats,
  dataset,
  scenes,
  form
});
